import { Model } from "@ofqual/portal-core/core/types";
import { injectHeaders } from "@ofqual/portal-core/core/utils/listHelpers";
import { ENRefData } from "../domain/ENRefData";

export const processConditions = (data: Model[]) => {
  const sortedData = data
    .map((item) => ({      
      id: item.id,
      label: `${item.code}: ${item.description}`,
      group: item.conditionCategory,
      active: item.active,
    }))
    .sort((a, b) => {
      if (a.group > b.group) {
        return 1;
      } else if (a.group < b.group) {
        return -1;
      }

      if (a.id > b.id) {
        return 1;
      } else if (a.id < b.id) {
        return -1;
      }
      return 0;
    });

  return injectHeaders(sortedData, (item) => item.group);
};

export const processSubConditions = (data: Model[]) => {
  const sortedData = data
    .map((item) => ({      
      id: item.id,
      parentId: item.parentID,
      label: item.code,
      group: item.conditionCategory,
      active: item.active,
      sortOrder: item.sortOrder
    }))
    .sort((a, b) => {

      if (a.group > b.group) {
        return 1;
      } else if (a.group < b.group) {
        return -1;
      }

      if ( a.sortOrder > b.sortOrder) {
        return 1;
      } else if (a.sortOrder < b.sortOrder) {
        return -1;
      }
      return 0;
    }
  )
  return injectHeaders(sortedData, (item) => item.group);
};


export const genericRefDataSort = (data: ENRefData[]) => {
  const compare = (a: number, b: number) => (a > b ? 1 : 0) - (a < b ? 1 : 0);
  return data.sort((a, b) => 
    compare(a.sortOrder, b.sortOrder) || a.value.localeCompare(b.value)
  );
}

export const genericRefDataMap = (data: ENRefData[]) => {
  return data.map(x => ({ id: x.id, label: x.value, active: x.active }));
}